import { BARS_AND_SECTORS_ES_ES } from "#pages/place/bars/translations/bars-and-sectors-es-es";
import { IMPORT_ES_ES } from "#pages/place/purchase-invoice/import-invoice/translations/import-es-es";
import { PURCHASE_INVOICE_ES_ES } from "#pages/place/purchase-invoice/translations/purchase-invoice-es-es";
import { TEAM_ES_ES } from "#pages/team/translations/team-es-es";
import { merge } from "lodash-es";
import es_MXJson from "../es-MX/es-MX.json";
import { delivery } from "../es-MX/place/delivery";
import { backofficeEsES as backoffice } from "./backoffice";
import { components } from "./components";
import { precharge_ES_MX as precharge } from "#pages/place/precharge/pages/translations";
import { event } from "./event";
import { navES } from "./nav";
import { integrations } from "./org/integrations";
import { ORG_PRODUCTS_ES_ES } from "./org/products";
import { clientArea } from "./org/client-area";
import { noAuthESES as noAuth } from "./no-auth";
import { emissionErrors } from "./place/emission-errors";
import { tableRangeSettings } from "./place/products/bars/table-range-settings";
import { COMBO_ES_ES } from "./place/products/combo";
import { REGISTER_EMAIL_ES_ES } from "./recovery/register-email";
import { TRANSACTIONS_REPORT_ES_ES } from "#components/transactions-report/translations";
import { BONUS_CATEGORIES_ES_ES } from "#pages/place/bonus-categories/translations";
import { settings } from "./place/settings";

const managerOrdersEsEs = {
	orderDetailModal: {
		title: "Detalles del pedido",
		orderNumber: "Pedido n.º #{{orderNumber}}",
		nameLabel: "Nombre",
		dateLabel: "Día y hora",
		dateValue: "{{date}} a las {{hour}}",
		originLabel: "Origen del pedido",
		refuseOrder: "Rechazar pedido",
		acceptOrder: "Aceptar pedido",
		cancelOrder: "Cancelar pedido",
		dispatchOrder: "Despachar pedido",
		concludeOrder: "Concluir pedido",
		itemsTitle: "Artículos del pedido",
		totalLabel: "Total del pedido",
		deliveryFeeLabel: "Gastos de envío",
		discountLabel: "Descuento",
		obsLabel: "Observación",
		obsTitle: "Observaciones adicionales",
		deliveryDetailsTitle: "Detalles de entrega",
		paymentMethodLabel: "Método de pago",
		addressLabel: "Dirección",
		contactLabel: "Contacto",
		cpfLabel: "CPF",
		phoneLabel: "Teléfono",
		unknownLabel: "Documento desconocido",
		unknown: "No indicado",
	},
};

const es_ES = merge(es_MXJson, {
	components,
	backoffice,
	place: {
		managerOrders: managerOrdersEsEs,
		purchaseInvoiceV2: PURCHASE_INVOICE_ES_ES,
		import: IMPORT_ES_ES,
		delivery,
		barsAndSectors: BARS_AND_SECTORS_ES_ES,
		emissionErrors,
		precharge,
		products: {
			bars: {
				tableRangeSettings,
			},
			combo: COMBO_ES_ES,
		},
		transactionsReport: TRANSACTIONS_REPORT_ES_ES,
		bonusCategories: BONUS_CATEGORIES_ES_ES,
		settings,
	},
	recovery: {
		registerEmail: REGISTER_EMAIL_ES_ES,
	},
	event,
	team: TEAM_ES_ES,
	nav: navES,
	noAuth,
	org: {
		integrations,
		products: ORG_PRODUCTS_ES_ES,
		clientArea,
	},
});

export { es_ES };
